import React, { useState } from 'react'
import {
  Router, Switch, Route, Redirect,
} from 'react-router-dom'
import { Persist } from 'formik-persist'
import queryString from 'query-string'
import  uuidv4 from 'uuid/v4'
import { Formik, Form } from 'formik'
import { AppSchema } from './utils/formik'
import './styles/app.css'
import Layout from './layout/layout.jsx'
import SignUp from './auth/signUp.jsx'
import EmailVerification from './auth/emailVerification.jsx'
import UploadMedicalLicense from './upload/uploadMedicalLicense.jsx'
import UpdateProfile from './profile/updateProfile.jsx'
import SuccessResult from './results/successResult.jsx'
import { updateProfileAPICall } from './apis/profile'
import { errorNotification } from './utils/helpers'
import LoadingSpinner from './partials/loadingSpinner'
import AuthService from './services/AuthService'
import history from './layout/history'
import { getCheckGroupAPICall, postCreateGroupAPICall } from './apis/group'
import { patchExistingUserAPICall } from './apis/user'
import { postCreateFacilityAPICall } from './apis/facility'

const auth = new AuthService()


function App() {
  const [currentAuthState, setCurrentAuthState] = useState('');

  const handleAuthentication = (nextState) => {
    if (
      /access_token|id_token|error/.test(nextState.location.hash) &&
      !currentAuthState
    ) {
      setCurrentAuthState(nextState);
      auth.handleAuthentication();
    }
  };

  const onSubmit = async (values, callback) => {
    const {
      name, email, phonePrefix, phone, password, facilityName, country, cityState, groupId, ...restValues
    } = values


    const userProfile = auth.getUserProfile()
    const userId = userProfile && userProfile.sub
      const updatedAppMetadata = {
        app_metadata: {
          affiliated_group: "",
          admin: '1',
          main: '1',
          approved_facilities: [],
          associated_groups: []
        }
      }

    let updatedGroupId = groupId
    if(facilityName && !groupId){
      const { responseJSON } = await getCheckGroupAPICall({ userGroupName:facilityName })
      if (responseJSON && responseJSON.length > 0) {
        errorNotification('Radiologist group already exists.')
        history.push('/')
        return
      } else{
        const { responseOk: createGroupResponseOk, responseJSON: createGroupResponse } = await postCreateGroupAPICall({userGroupName:facilityName})
         if (createGroupResponseOk) {
          updatedGroupId = createGroupResponse && createGroupResponse['group_id'];
          updatedAppMetadata.app_metadata.affiliated_group = updatedGroupId
           const { responseOk: userUpdateOk } = await patchExistingUserAPICall(userId, { appMetadata: updatedAppMetadata })
            if(userUpdateOk){
              const { responseOk:facilityResponseOk, responseJSON:facilityResponseJSON }  = await postCreateFacilityAPICall({userFacilityCity: cityState, userFacilityCountry: country, userFacilityName: facilityName})
              if(facilityResponseOk){
                updatedAppMetadata.app_metadata.approved_facilities.push(facilityResponseJSON.guid)
                await patchExistingUserAPICall(userId, { appMetadata: updatedAppMetadata })
              }
            }
        }

      }
    }

    if(groupId){
      updatedAppMetadata.app_metadata.associated_groups.push(updatedGroupId)
      await patchExistingUserAPICall(userId, { appMetadata: updatedAppMetadata })
    }


    const payload = {
      guid: uuidv4(),
      name,
      email,
      phone: `+${phonePrefix}${phone}`,
      facilityName,
      cityState,
      country,
      ...restValues,
    }

    const response = await updateProfileAPICall(payload)
    const responseOk = await response.status === 200
    if(response && responseOk){
      callback(response)
    } else{
      errorNotification('Update profile failed. Please try again.')
      callback(false)
    }
  }

  return (
    <div className="app">
      <Router basename='/' history={history}>
        <Route
          render={({ location, history }) => {
            // console.log('location.search', location.search)
            // console.log(queryString.parse(location.search))
            const {
              Name: name,
              email,
              facility: facilityName,
              CC: phonePrefix = '65',
              groupId
            } = queryString.parse(location.search)

            const initialValues = {
              name,
              email,
              phonePrefix,
              phone: '',
              password: '',
              facilityName,
              medicalLicense: null,
              profilePhoto: '',
              groupId,
              profilePhotoFile: null,
              speciality: {
                name: '',
              },
              specialities: [],
              cityState: '',
              // address: {
              //   country: '',
              //   state: '',
              //   city: '',
              //   street: '',
              // },
              gender: 'male',
              educations: [],
              education: {
                qualification: '',
                school: '',
                year: '',
              },
            }

            return (
              <Formik
                initialValues={initialValues}
                validationSchema={AppSchema}
                // validate={validate}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  // console.log('onSubmit values', values)
                  const {
                    education, speciality, ...restValues
                  } = values

                  onSubmit(restValues, (response) => {
                    // console.log('response', response)
                    // JSON.stringify(values, null, 2)
                    // setSubmitting(false)
                    resetForm()
                    if(response){
                      history.push('/result/success')
                    } else{
                      history.push('/')
                    }
                  })
                }}
                render={(props) => {
                  console.log('App formik props', props)
                  return (
                    <Form>
                      <Layout>
                        <Switch>
                        <Route exact path='/auth0-callback' render={(props) => {
                            handleAuthentication(props)
                            return <LoadingSpinner {...props} />
                          }} />
                          <Route path="/signup" component={SignUp} />
                          <Route path="/verification" component={EmailVerification} />
                          <Route path="/upload/medical-license" component={UploadMedicalLicense} />
                          <Route path="/update/profile" component={UpdateProfile} />
                          <Route path="/result/success" component={SuccessResult} />
                          <Redirect to="/signup" />
                        </Switch>
                      </Layout>
                      <Persist name="signup-form" />
                    </Form>
                  )
                }}
              />
            )
          }}
        />
      </Router>
    </div>
  )
}

export default App
